import { onMounted, onUnmounted, watch } from 'vue'
import { useGtmVar } from '@/composables/app/gtm/useGtmVar'
import { useSegmentProductAnalytics } from '@/views/product/composables/analytics/useSegmentProductAnalytics'
import type { ProductAnalyticsFragment } from '@/graphql/api'
import type { ReadonlyRef } from '@/helpers'
import { useSegment } from '@/third-party/segment.ts'
import type { RingBuilder } from '@/plugins/ring-builder.ts'

export function useProductAnalytics(
    product: ReadonlyRef<ProductAnalyticsFragment | undefined | null>,
    fetching: ReadonlyRef<boolean>,
    ringBuilder?: ReadonlyRef<RingBuilder | undefined>
): void {
    const { track } = useSegment()
    const serialize = useSegmentProductAnalytics()

    const contentIds = useGtmVar('content_ids', '' as string)

    let lastId: string | undefined = undefined

    const trackViewed = () => {
        if (ringBuilder && !ringBuilder.value) {
            return
        }

        const productValue = product.value

        if (
            !productValue ||
            productValue.catalogueCode === lastId ||
            fetching.value
        ) {
            return
        }

        contentIds.value = productValue.catalogueCode

        track('Product Viewed', serialize(productValue, ringBuilder?.value))

        lastId = productValue.catalogueCode
    }

    watch([product, () => ringBuilder?.value], trackViewed)

    onUnmounted(() => {
        lastId = undefined
    })

    onMounted(trackViewed)
}
